import { makeStyles } from "components/providers/makeStyles";

export const useSharedMediaStyles = makeStyles((theme) => ({
    thumbnail: {
        aspectRatio: "1 / 1",
        width: "100%",
        borderRadius: theme.spacing(1),
        objectFit: "cover",
        // Hides alt text from showing while loading. This should be replaced with a proper solution for image loading state
        fontSize: 0,
    }
}));
